var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.45 93.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.33,40.68v-13.03c0-7.63-2.7-14.15-8.1-19.55C54.92,2.7,48.41,0,40.77,0s-14.24,2.7-19.55,8.1c-5.4,5.4-8.1,11.92-8.1,19.55v13.03h-4.38c-2.42,0-4.47,.93-6.24,2.61-1.68,1.68-2.51,3.72-2.51,6.14v34.91c0,2.42,.84,4.47,2.51,6.24,1.77,1.68,3.82,2.51,6.24,2.51h63.95c2.42,0,4.47-.84,6.24-2.51,1.68-1.77,2.51-3.82,2.51-6.24V49.43c0-2.42-.84-4.47-2.51-6.14-1.77-1.68-3.82-2.61-6.24-2.61h-4.38Zm-40.68,0v-13.03c0-3.63,1.3-6.7,3.82-9.31,2.51-2.51,5.59-3.82,9.31-3.82s6.7,1.3,9.22,3.82c2.51,2.61,3.82,5.68,3.82,9.31v13.03H27.65Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b5487c342dcad26a75c64d82cfd3e5e4.svg";
export { ForwardRef as ReactComponent };